const styles = (theme) => ({
    visibility: {
        cursor: 'pointer',
    },
    root: {},
    input: {},
});

export default styles;
